<template>

  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row no-gutters class="!justify-center !h-screen  overflow-y-auto bg-black">
      <v-col class="p-10 px-4 !max-w-[500px]">
        <v-card-title class="justify-center py-6 text-center">
          <h4 class="text-3xl basil--text titleText">Profile Settings</h4>
        </v-card-title>
        <v-card dark class="edit-form font-Handel" color="transparent" elevation="0">
          <v-text-field dark v-model="age" :rules="nameRules" label="Your Age" required />
          <v-text-field dark v-model="location" :counter="50" :rules="nameRules" label=" Your Location" required />
          <v-select dark flat attach v-model="education" :rules="nameRules" label=" Your Education" :items="educations"
            required />
          <v-text-field dark v-model="job" :counter="25" :rules="nameRules" label=" Your Job" required />
          <p style="color: white">Age Range</p>

          <v-range-slider v-model="init_partner_age_range" :max="max" :min="min" dark hide-details class="align-center"
            color="rgb(174 140 57)">
            <template v-slot:prepend>
              <v-text-field :value="init_partner_age_range[0]" background-color="rgb(174 140 57)" solo dense class="pt-0 mt-0"
                hide-details single-line type="number" style="width: 65px" @change="$set(init_partner_age_range, 0, $event)">
              </v-text-field>
            </template>
            <template v-slot:append>
              <v-text-field solo dense :value="init_partner_age_range[1]" background-color="rgb(174 140 57)" class="pt-0 mt-0"
                hide-details single-line type="number" style="width: 65px" @change="$set(init_partner_age_range, 1, $event)">
              </v-text-field>
            </template>
          </v-range-slider>
          <v-select v-model="interest" flat dark deletable-chips small-chips :items="interests" item-text="title"
            item-value="id" attach chips label="Select Hobbies" multiple :rules="hobbiesRule" />
          <v-textarea class="pt-0" dark counter label="BIO" :rules="nameRules" v-model="about" :rows="4" />

          <v-file-input dark v-model="image" accept="image/png, image/jpeg, image/bmp"
            placeholder="Upload Profile Image" prepend-icon="mdi-camera" label="Profile Picture" outlined class="pt-5 ">
            <template v-slot:selection="{ text }">
              <v-chip small label color="#ae8c39">
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>
        </v-card>
        <v-card-title class="justify-center py-6 text-center">
          <h4 class="text-3xl basil--text titleText">Upload Gallery Images</h4>
        </v-card-title>
        <v-card color="transparent" elevation="0" class="text-center filter-switch">
          <!-- <v-textarea class="pt-0" dark label="Description" :rules="nameRules" v-model="description" :rows="4" /> -->

          <v-file-input dark v-model="images" accept="image/png, image/jpeg, image/bmp,  image/webp"
            :counter="premiumChecker ? 6 : 3" prepend-icon="mdi-camera" label="Upload Gallery Image" multiple outlined
            chips show-size class="font-Handel">
            <template v-slot:selection="{ text }">
              <v-chip small label color="#ae8c39">
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>
        </v-card>
        <v-btn dark @click.prevent="completeProfile" :loading="completeProfloading" class="white--text color float-right my-10">Start Dating</v-btn>


      </v-col>

    </v-row>
  </v-form>

</template>

<script>
import axios from "axios";
import PrivacyPolicy from "@/components/settings/PrivacyPolicy.vue";
import { CometChat } from "@cometchat-pro/chat";
export default {
  data() {
    return {
      description: '',
      rules: [
        (v) =>
          !!v || v.size < 2000000 || "Avatar size should be less than 2 MB!",
      ],
      nameRules: [(v) => !!v || "This field is required!"],
      galleryRule: [
        (v) => !!v || "Gallery images are required!",
        (v) => !!v.length < 3 || "Gallery images should be less than 3",
      ],
      hobbiesRule: [(v) => !!v.length || "Hobbies are required!"],
      min: 18,
      max: 50,
      init_partner_age_range: [20, 30],
      checkbox: true,
      tab: null,
      items: [
        "Travel",
        "Hiking",
        "Running",
        "Camping",
        "Cooking",
        "Kayaking",
        "Cycling",
        "Hunting",
        "Listening to Music",
        "Singing",
        "Gaming",
        "Sports",
        "Shopping",
        "Photography",
        "Painting",
        "Scuba diving",
      ],
      avatar: undefined,
      educations: ["Highschool", "Bachelors", "Masters", "PhD"],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      age: '',
      location: '',
      education: '',
      job: '',
      hobbies: '',
      about: '',
      images: [],
      image: [],
      valid: false,
      interests: [],
      interest: [],
      partner_age_range:[],
      completeProfloading:false,
    };
  },
  computed: {

    premiumChecker() {
      return this.$store.getters.isPremium;
    },
    fetchSettings() {
      if (this.$store.getters.getSettings) {
        return this.$store.getters.getSettings;
      } else {
        this.$store.dispatch("GetSettings");
        return this.$store.getters.getSettings;
      }
    },
  },
  methods: {
    updateAvatar() {
      let authKey = process.env.VUE_APP_COMET_CHAT_APP_AUTH_KEY;
      let uid = this.$store.getters.getCometUUID;
      let avatar = this.$store.getters.StateUser.data.image


      var user = new CometChat.User(uid);

      user.setAvatar(avatar);

      CometChat.updateUser(user, authKey).then(
        user => {
          console.log("user updated", user);
        }, error => {
          console.log("error", error);
        }
      )
    },
    async getInterests() {
      try {
        const resp = await axios.get("interests");

        this.interests = resp.data.data


      } catch (error) {

      }
    },
    async completeProfile() {
      const agerangeSet = this.partner_age_range = `${this.init_partner_age_range[0]} to ${this.init_partner_age_range[1]}`
      const data = new FormData()
      data.append('age', this.age);
      data.append('education', this.education);
      data.append('location', this.location);
      data.append('job', this.job);
      data.append('partner_age_range', agerangeSet);
      data.append('about', this.about);
      if (this.image != '') {
        const image = []
        image.push(this.image)
        // console.log(image)
        data.append("image[]", image[0], image[0].name);
      }
      if (this.images.length > 0) {
        console.log(this.images)
        for (let file of this.images) {
          console.log(file)
          data.append("images[]", file, file.name);
        }
      }
      if (this.interest != undefined) {
        for (let interest of this.interest) {
          data.append("interest[]", interest);
        }
      }
      try {
        this.completeProfloading = true;
        this.$refs.form.validate();
        const resp = await axios({
          method: "post",
          url: "complete-profile",
          data: data,
        });
        const rData = resp.data;
        console.log(rData);
        // const state = this.$store.getters.StateUser;
        
        await this.$store.dispatch("restoreData", rData);
        localStorage.setItem("userInfo", JSON.stringify(rData));
        const types = {
          1: "lesbian",
          2: "gay",
          3: "straight",
        };
        const routeSetter = types[rData.data.account_type];
        console.log(routeSetter)
        this.$router.push(`/plan`);
      } catch (error) {
        console.error(error);
      } finally{
        this.completeProfloading = false;
        this.updateAvatar()

      }
    },
  },
  created() {
    this.getInterests()
  },
  components: { PrivacyPolicy },
};
</script>

<style scoped>
/* Helper classes */
.basil {
  background-color: #00000000 !important;
  border: none;
}

.basil--text {
  color: #ffffff !important;
}

.color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.v-select:deep(.v-list) {
  background-color: #111 !important;
}

.v-select:deep(.v-list-item__title) {
  color: #ae8c39 !important;
}

.v-input--range-slider .v-text-field:deep(.v-input__slot) {
  background: #ae8c39 !important;
}

.v-select:deep(.v-chip) {
  background-color: #ae8c39 !important;
}

.v-input--checkbox:deep(.v-label) {
  color: #ffffff !important;
  font-family: Handel Gothic;
}

.titleText {
  font-family: Handel Gothic;
  background: linear-gradient(200deg,
      rgba(219, 168, 59, 1) 0%,
      rgba(212, 181, 119, 1) 22%,
      rgba(174, 137, 53, 1) 30%,
      rgba(162, 124, 43, 1) 70%,
      rgba(212, 179, 116, 1) 80%,
      rgba(168, 122, 44, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
